import { isPasswordValidTest } from '../../utils/validators';
import { firstAccessMessages } from '../../messages';

export interface verifySetPasswordParams {
  newPassword: string;
  newPasswordConfirm: string;
}

export const verifySetPasswordCredentials = (
  formValues: verifySetPasswordParams
): any | undefined => {
  const { newPassword, newPasswordConfirm } = formValues;

  if (!newPassword || !newPasswordConfirm) {
    return { title: firstAccessMessages.errorTitleFillInAllFields };
  }
  if (newPassword !== newPasswordConfirm) {
    return { title: firstAccessMessages.errorTitlePasswordNotMatching };
  }
  if (!isPasswordValidTest(newPassword)) {
    return {
      title: firstAccessMessages.errorTitleInvalidCriteria,
      description: firstAccessMessages.errorDescriptionInvalidCriteria,
    };
  }
  return undefined;
};
